import type { ReactNode } from "react";
import { ClaudeMark, CopilotMark } from "@/components/icons";
import type { AiProvider } from "@/desktop/ui";
import { cn } from "@/lib/utils";

/** Marca de cada chat: a da Anthropic (Claude) e a do GitHub Copilot. */
export function ProviderMark({ provider, className }: { provider: AiProvider; className?: string }) {
  return provider === "claude" ? (
    <ClaudeMark className={cn("text-fg", className)} />
  ) : (
    <CopilotMark className={className} />
  );
}

/**
 * Barra de ações de um chat (agente, nova conversa…), logo abaixo das abas da lateral direita.
 * O nome e o fechar ficam nas abas.
 */
export function ChatHeader({ children }: { provider?: AiProvider; children?: ReactNode }) {
  if (!children) return null;
  return <div className="flex h-[34px] shrink-0 items-center justify-end gap-0.5 px-2">{children}</div>;
}
